"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_MODES = void 0;
exports.AUTH_MODES = ['password', 'passwordless', 'both'];
//# sourceMappingURL=auth-modes.js.map